import Phaser from 'phaser';

// Each sprite is a 2D array of hex colors (0 = transparent)
// Drawn on an NxN grid and scaled up

const _ = 0; // transparent

// --- Act 1 Normal Enemies ---

const SLIME: number[][] = [
  [_, _, _, 0x2e7d32, 0x2e7d32, _, _, _],
  [_, _, 0x4caf50, 0x66bb6a, 0x66bb6a, 0x4caf50, _, _],
  [_, 0x4caf50, 0x81c784, 0x81c784, 0x81c784, 0x81c784, 0x4caf50, _],
  [0x388e3c, 0x66bb6a, 0xffffff, 0x81c784, 0x81c784, 0xffffff, 0x66bb6a, 0x388e3c],
  [0x388e3c, 0x66bb6a, 0x2e7d32, 0x81c784, 0x81c784, 0x2e7d32, 0x66bb6a, 0x388e3c],
  [0x2e7d32, 0x4caf50, 0x66bb6a, 0x66bb6a, 0x66bb6a, 0x66bb6a, 0x4caf50, 0x2e7d32],
  [_, 0x2e7d32, 0x4caf50, 0x4caf50, 0x4caf50, 0x4caf50, 0x2e7d32, _],
  [_, _, 0x1b5e20, 0x2e7d32, 0x2e7d32, 0x1b5e20, _, _],
];

const GREMLIN: number[][] = [
  [_, _, 0x8d6e63, _, _, 0x8d6e63, _, _],
  [_, 0x8d6e63, 0xa1887f, 0x8d6e63, 0x8d6e63, 0xa1887f, 0x8d6e63, _],
  [_, 0xa1887f, 0xff0000, 0xa1887f, 0xa1887f, 0xff0000, 0xa1887f, _],
  [_, _, 0xa1887f, 0xa1887f, 0xa1887f, 0xa1887f, _, _],
  [_, _, _, 0x8d6e63, 0x8d6e63, _, _, _],
  [_, 0x6d4c41, 0x8d6e63, 0xa1887f, 0xa1887f, 0x8d6e63, 0x6d4c41, _],
  [_, _, 0x8d6e63, 0x8d6e63, 0x8d6e63, 0x8d6e63, _, _],
  [_, _, 0x6d4c41, _, _, 0x6d4c41, _, _],
];

const FUNGUS: number[][] = [
  [_, _, _, 0x8b4513, 0x8b4513, _, _, _],
  [_, _, 0xa0522d, 0xcd853f, 0xcd853f, 0xa0522d, _, _],
  [_, 0x8b4513, 0xcd853f, 0xffffff, 0xcd853f, 0xffffff, 0x8b4513, _],
  [0x8b4513, 0xa0522d, 0xcd853f, 0xcd853f, 0xcd853f, 0xcd853f, 0xa0522d, 0x8b4513],
  [_, 0x8b4513, 0xa0522d, 0xa0522d, 0xa0522d, 0xa0522d, 0x8b4513, _],
  [_, _, _, 0xd2b48c, 0xd2b48c, _, _, _],
  [_, _, _, 0xd2b48c, 0xd2b48c, _, _, _],
  [_, _, 0xd2b48c, 0xd2b48c, 0xd2b48c, 0xd2b48c, _, _],
];

const SKELETON: number[][] = [
  [_, _, 0xeeeeee, 0xeeeeee, 0xeeeeee, 0xeeeeee, _, _],
  [_, 0xeeeeee, 0x222222, 0xeeeeee, 0xeeeeee, 0x222222, 0xeeeeee, _],
  [_, 0xeeeeee, 0xeeeeee, 0xcccccc, 0xcccccc, 0xeeeeee, 0xeeeeee, _],
  [_, _, 0xeeeeee, 0x222222, 0x222222, 0xeeeeee, _, _],
  [_, _, _, 0xcccccc, 0xcccccc, _, _, _],
  [_, 0xeeeeee, 0xcccccc, 0xeeeeee, 0xeeeeee, 0xcccccc, 0xeeeeee, _],
  [_, _, 0xeeeeee, 0xcccccc, 0xcccccc, 0xeeeeee, _, _],
  [_, _, 0xcccccc, _, _, 0xcccccc, _, _],
];

// --- Act 1 Elites ---

const MIRROR_GOLEM: number[][] = [
  [_, _, 0x90caf9, 0xbbdefb, 0xbbdefb, 0x90caf9, _, _],
  [_, 0x90caf9, 0xbbdefb, 0xe3f2fd, 0xe3f2fd, 0xbbdefb, 0x90caf9, _],
  [0x64b5f6, 0xbbdefb, 0xffffff, 0xbbdefb, 0xbbdefb, 0xffffff, 0xbbdefb, 0x64b5f6],
  [0x64b5f6, 0x90caf9, 0xbbdefb, 0xbbdefb, 0xbbdefb, 0xbbdefb, 0x90caf9, 0x64b5f6],
  [_, 0x42a5f5, 0x90caf9, 0x64b5f6, 0x64b5f6, 0x90caf9, 0x42a5f5, _],
  [_, 0x42a5f5, 0x64b5f6, 0x90caf9, 0x90caf9, 0x64b5f6, 0x42a5f5, _],
  [_, _, 0x42a5f5, 0x64b5f6, 0x64b5f6, 0x42a5f5, _, _],
  [_, 0x42a5f5, _, 0x42a5f5, 0x42a5f5, _, 0x42a5f5, _],
];

const NUMBER_LEECH: number[][] = [
  [_, _, _, _, _, _, _, _],
  [_, _, 0x7b1fa2, 0x9c27b0, 0x9c27b0, 0x7b1fa2, _, _],
  [_, 0x7b1fa2, 0xce93d8, 0xab47bc, 0xab47bc, 0xce93d8, 0x7b1fa2, _],
  [0x6a1b9a, 0xce93d8, 0xffffff, 0xab47bc, 0xab47bc, 0xffffff, 0xce93d8, 0x6a1b9a],
  [0x6a1b9a, 0x9c27b0, 0xab47bc, 0x9c27b0, 0x9c27b0, 0xab47bc, 0x9c27b0, 0x6a1b9a],
  [_, 0x7b1fa2, 0x9c27b0, 0x7b1fa2, 0x7b1fa2, 0x9c27b0, 0x7b1fa2, _],
  [_, _, 0x7b1fa2, 0x6a1b9a, 0x6a1b9a, 0x7b1fa2, _, _],
  [_, _, _, 0x6a1b9a, 0x6a1b9a, _, _, _],
];

const CRYSTAL_GUARDIAN: number[][] = [
  [_, _, _, 0x00bcd4, _, _, _, _],
  [_, _, 0x00bcd4, 0x4dd0e1, 0x00bcd4, _, _, _],
  [_, 0x00838f, 0x4dd0e1, 0x80deea, 0x4dd0e1, 0x00838f, _, _],
  [0x00838f, 0x00bcd4, 0x80deea, 0xffffff, 0x80deea, 0x00bcd4, 0x00838f, _],
  [_, 0x00838f, 0x4dd0e1, 0x80deea, 0x4dd0e1, 0x00838f, _, _],
  [_, _, 0x00838f, 0x00bcd4, 0x00838f, _, _, _],
  [_, _, _, 0x00838f, _, _, _, _],
  [_, _, _, _, _, _, _, _],
];

// --- Act 2 Normal Enemies ---

const SHADE: number[][] = [
  [_, _, _, 0x4a148c, 0x4a148c, _, _, _],
  [_, _, 0x4a148c, 0x6a1b9a, 0x6a1b9a, 0x4a148c, _, _],
  [_, 0x4a148c, 0xff9800, 0x6a1b9a, 0x6a1b9a, 0xff9800, 0x4a148c, _],
  [_, 0x4a148c, 0x6a1b9a, 0x7b1fa2, 0x7b1fa2, 0x6a1b9a, 0x4a148c, _],
  [0x311b92, 0x6a1b9a, 0x7b1fa2, 0x6a1b9a, 0x6a1b9a, 0x7b1fa2, 0x6a1b9a, 0x311b92],
  [0x311b92, 0x4a148c, 0x6a1b9a, 0x6a1b9a, 0x6a1b9a, 0x6a1b9a, 0x4a148c, 0x311b92],
  [_, 0x311b92, 0x4a148c, 0x4a148c, 0x4a148c, 0x4a148c, 0x311b92, _],
  [_, _, 0x311b92, _, _, 0x311b92, _, _],
];

const BERSERKER: number[][] = [
  [_, _, 0xbf360c, _, _, 0xbf360c, _, _],
  [_, 0xbf360c, 0xe65100, 0xbf360c, 0xbf360c, 0xe65100, 0xbf360c, _],
  [_, 0xe65100, 0xff0000, 0xe65100, 0xe65100, 0xff0000, 0xe65100, _],
  [_, _, 0xe65100, 0xff6d00, 0xff6d00, 0xe65100, _, _],
  [_, 0xbf360c, 0xe65100, 0xff6d00, 0xff6d00, 0xe65100, 0xbf360c, _],
  [0xbf360c, 0xe65100, 0xff6d00, 0xe65100, 0xe65100, 0xff6d00, 0xe65100, 0xbf360c],
  [_, _, 0xe65100, 0xbf360c, 0xbf360c, 0xe65100, _, _],
  [_, _, 0xbf360c, _, _, 0xbf360c, _, _],
];

const WRAITH: number[][] = [
  [_, _, _, 0x1a237e, 0x1a237e, _, _, _],
  [_, _, 0x283593, 0x3949ab, 0x3949ab, 0x283593, _, _],
  [_, 0x283593, 0x42a5f5, 0x3949ab, 0x3949ab, 0x42a5f5, 0x283593, _],
  [_, 0x1a237e, 0x3949ab, 0x5c6bc0, 0x5c6bc0, 0x3949ab, 0x1a237e, _],
  [0x1a237e, 0x283593, 0x3949ab, 0x283593, 0x283593, 0x3949ab, 0x283593, 0x1a237e],
  [_, 0x1a237e, 0x283593, 0x283593, 0x283593, 0x283593, 0x1a237e, _],
  [_, _, 0x1a237e, _, _, 0x1a237e, _, _],
  [_, _, _, 0x1a237e, 0x1a237e, _, _, _],
];

// --- Act 2 Elites ---

const CLOCKWORK_KNIGHT: number[][] = [
  [_, _, 0xffa000, 0xffb300, 0xffb300, 0xffa000, _, _],
  [_, 0xffa000, 0xffb300, 0xffd54f, 0xffd54f, 0xffb300, 0xffa000, _],
  [_, 0xffa000, 0x333333, 0xffb300, 0xffb300, 0x333333, 0xffa000, _],
  [0xff8f00, 0xffa000, 0xffb300, 0xffa000, 0xffa000, 0xffb300, 0xffa000, 0xff8f00],
  [_, 0xff8f00, 0xffa000, 0xffb300, 0xffb300, 0xffa000, 0xff8f00, _],
  [_, 0xff8f00, 0xffa000, 0xff8f00, 0xff8f00, 0xffa000, 0xff8f00, _],
  [_, _, 0xff8f00, 0xffa000, 0xffa000, 0xff8f00, _, _],
  [_, 0xff8f00, _, 0xff8f00, 0xff8f00, _, 0xff8f00, _],
];

const VOID_EATER: number[][] = [
  [_, _, 0x1a1a2e, 0x0d0d1a, 0x0d0d1a, 0x1a1a2e, _, _],
  [_, 0x1a1a2e, 0x2d1b4e, 0x1a1a2e, 0x1a1a2e, 0x2d1b4e, 0x1a1a2e, _],
  [0x1a1a2e, 0x2d1b4e, 0xff00ff, 0x2d1b4e, 0x2d1b4e, 0xff00ff, 0x2d1b4e, 0x1a1a2e],
  [0x0d0d1a, 0x1a1a2e, 0x2d1b4e, 0x0d0d1a, 0x0d0d1a, 0x2d1b4e, 0x1a1a2e, 0x0d0d1a],
  [0x0d0d1a, 0x2d1b4e, 0x1a1a2e, 0x2d1b4e, 0x2d1b4e, 0x1a1a2e, 0x2d1b4e, 0x0d0d1a],
  [_, 0x1a1a2e, 0x2d1b4e, 0x1a1a2e, 0x1a1a2e, 0x2d1b4e, 0x1a1a2e, _],
  [_, _, 0x1a1a2e, 0x0d0d1a, 0x0d0d1a, 0x1a1a2e, _, _],
  [_, _, _, 0x1a1a2e, 0x1a1a2e, _, _, _],
];

// --- Bosses (12x12) ---

const ABACUS: number[][] = [
  [_, _, _, 0xbf8040, 0xbf8040, 0xbf8040, 0xbf8040, 0xbf8040, 0xbf8040, _, _, _],
  [_, _, 0xa06030, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xa06030, _, _],
  [_, 0xa06030, 0xdaa520, 0xff4444, 0xff4444, 0xdaa520, 0xdaa520, 0x4488ff, 0x4488ff, 0xdaa520, 0xa06030, _],
  [_, 0xa06030, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xa06030, _],
  [_, 0xa06030, 0xdaa520, 0x44ff44, 0xdaa520, 0x44ff44, 0xdaa520, 0xffd700, 0xdaa520, 0xdaa520, 0xa06030, _],
  [_, 0xa06030, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xa06030, _],
  [_, 0xa06030, 0xdaa520, 0xdaa520, 0xff4444, 0xdaa520, 0xdaa520, 0x4488ff, 0xdaa520, 0xdaa520, 0xa06030, _],
  [_, 0xa06030, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xa06030, _],
  [_, _, 0xa06030, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xdaa520, 0xa06030, _, _],
  [_, _, _, 0xa06030, 0xbf8040, 0xa06030, 0xa06030, 0xbf8040, 0xa06030, _, _, _],
  [_, _, _, _, 0xa06030, _, _, 0xa06030, _, _, _, _],
  [_, _, _, 0xa06030, 0xa06030, 0xa06030, 0xa06030, 0xa06030, 0xa06030, _, _, _],
];

const EQUATION: number[][] = [
  [_, _, _, 0x1565c0, 0x1976d2, 0x1976d2, 0x1976d2, 0x1976d2, 0x1565c0, _, _, _],
  [_, _, 0x1565c0, 0x42a5f5, 0x64b5f6, 0x64b5f6, 0x64b5f6, 0x64b5f6, 0x42a5f5, 0x1565c0, _, _],
  [_, 0x1565c0, 0x42a5f5, 0xffffff, 0x64b5f6, 0x42a5f5, 0x42a5f5, 0x64b5f6, 0xffffff, 0x42a5f5, 0x1565c0, _],
  [0x0d47a1, 0x1976d2, 0x42a5f5, 0x1976d2, 0x42a5f5, 0x64b5f6, 0x64b5f6, 0x42a5f5, 0x1976d2, 0x42a5f5, 0x1976d2, 0x0d47a1],
  [0x0d47a1, 0x1565c0, 0x1976d2, 0x42a5f5, 0x42a5f5, 0xffd700, 0xffd700, 0x42a5f5, 0x42a5f5, 0x1976d2, 0x1565c0, 0x0d47a1],
  [_, 0x0d47a1, 0x1565c0, 0x1976d2, 0x42a5f5, 0xffd700, 0xffd700, 0x42a5f5, 0x1976d2, 0x1565c0, 0x0d47a1, _],
  [_, 0x0d47a1, 0x1565c0, 0x1976d2, 0x42a5f5, 0xffd700, 0xffd700, 0x42a5f5, 0x1976d2, 0x1565c0, 0x0d47a1, _],
  [0x0d47a1, 0x1565c0, 0x1976d2, 0x42a5f5, 0x42a5f5, 0xffd700, 0xffd700, 0x42a5f5, 0x42a5f5, 0x1976d2, 0x1565c0, 0x0d47a1],
  [0x0d47a1, 0x1976d2, 0x42a5f5, 0x1976d2, 0x42a5f5, 0x64b5f6, 0x64b5f6, 0x42a5f5, 0x1976d2, 0x42a5f5, 0x1976d2, 0x0d47a1],
  [_, 0x1565c0, 0x42a5f5, 0xffffff, 0x64b5f6, 0x42a5f5, 0x42a5f5, 0x64b5f6, 0xffffff, 0x42a5f5, 0x1565c0, _],
  [_, _, 0x1565c0, 0x42a5f5, 0x64b5f6, 0x64b5f6, 0x64b5f6, 0x64b5f6, 0x42a5f5, 0x1565c0, _, _],
  [_, _, _, 0x1565c0, 0x1976d2, 0x1976d2, 0x1976d2, 0x1976d2, 0x1565c0, _, _, _],
];

type SpriteId = 'slime' | 'gremlin' | 'fungus' | 'skeleton'
  | 'mirror_golem' | 'number_leech' | 'crystal_guardian'
  | 'shade' | 'berserker' | 'wraith'
  | 'clockwork_knight' | 'void_eater'
  | 'abacus' | 'equation';

const SPRITE_MAP: Record<SpriteId, number[][]> = {
  slime: SLIME,
  gremlin: GREMLIN,
  fungus: FUNGUS,
  skeleton: SKELETON,
  mirror_golem: MIRROR_GOLEM,
  number_leech: NUMBER_LEECH,
  crystal_guardian: CRYSTAL_GUARDIAN,
  shade: SHADE,
  berserker: BERSERKER,
  wraith: WRAITH,
  clockwork_knight: CLOCKWORK_KNIGHT,
  void_eater: VOID_EATER,
  abacus: ABACUS,
  equation: EQUATION,
};

const NAME_TO_ID: Record<string, SpriteId> = {
  'Slime': 'slime',
  'Gremlin': 'gremlin',
  'Fungus': 'fungus',
  'Skeleton': 'skeleton',
  'Mirror Golem': 'mirror_golem',
  'Number Leech': 'number_leech',
  'Crystal Guardian': 'crystal_guardian',
  'Shade': 'shade',
  'Berserker': 'berserker',
  'Wraith': 'wraith',
  'Clockwork Knight': 'clockwork_knight',
  'Void Eater': 'void_eater',
  'The Abacus': 'abacus',
  'The Equation': 'equation',
};

export function drawEnemySprite(
  scene: Phaser.Scene,
  x: number,
  y: number,
  enemyName: string,
  displaySize: number,
): Phaser.GameObjects.Graphics {
  const id = NAME_TO_ID[enemyName];
  const data = id ? SPRITE_MAP[id] : SLIME;
  const g = scene.add.graphics();
  const rows = data.length;
  const cols = Math.max(...data.map(r => r.length));
  const pixelSize = displaySize / Math.max(rows, cols);

  const startX = x - (cols * pixelSize) / 2;
  const startY = y - (rows * pixelSize) / 2;

  for (let r = 0; r < rows; r++) {
    for (let c = 0; c < data[r].length; c++) {
      if (data[r][c] === 0) continue;
      g.fillStyle(data[r][c]);
      g.fillRect(
        startX + c * pixelSize,
        startY + r * pixelSize,
        pixelSize,
        pixelSize,
      );
    }
  }

  return g;
}

export function isBossEnemy(name: string): boolean {
  const id = NAME_TO_ID[name];
  return id === 'abacus' || id === 'equation';
}
